import axios from 'axios';
import config from '../config';

export const signUp = (data) =>
  axios.request({
    method: 'post',
    url: `${config.providerApiInternal}/providers/signup`,
    data,
  });



// WEBPACK FOOTER //
// ./src/api/signUpForm.js